module.exports = __webpack_public_path__ + "js/0.68714461.worker.js"